import { OfferDto } from "@intelligems/ig-types";
import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "@src/store";
import { selectedOffers } from "@src/store/slices/offers";

export const getVariationOffer =
  (variationId: string) =>
  (state: RootState): OfferDto => {
    const offers = selectedOffers(state);
    return (
      offers.find((offer) => offer.variationId === variationId) || offers[0]
    );
  };

export const getShippingDiscount =
  (variationId: string) => (state: RootState) => {
    const offer = getVariationOffer(variationId)(state);
    return offer?.shippingDiscount ?? undefined;
  };

export const getVariationOfferTier =
  (variationId: string, tierIndex: number) => (state: RootState) => {
    const offer = getVariationOffer(variationId)(state);
    return offer?.tiers[tierIndex];
  };

// https://redux.js.org/usage/deriving-data-selectors#selector-factories
export const getOfferByVariationIdFactory = (variationId: string) =>
  createSelector(
    (state: RootState) => state.offers.offers,
    (offers) =>
      offers.find((offer) => offer.variationId === variationId) || offers[0]
  );

export const getShippingDiscountFactory = (variationId: string) =>
  createSelector(
    getOfferByVariationIdFactory(variationId),
    (offer) => offer.shippingDiscount
  );
